import IntakeVideoCallBookingContainer from './IntakeVideoCallBookingContainer'

export default IntakeVideoCallBookingContainer
